import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import mark from './assets/sustune_mark.png';
import './Navbar.css';

const links = [
  { to: '/solutions', label: 'Solutions' },
  { to: '/about', label: 'About' },
  { to: '/resources', label: 'Resources' },
  { to: '/contact', label: 'Contact' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="wrap header-inner">
        <Link to="/" className="wordmark" onClick={() => setOpen(false)}>
          <img src={mark} alt="" className="wordmark-logo" />
          <span className="wordmark-text">
            <span className="wordmark-main">Sustune</span>
            <span className="wordmark-sub">Technologies</span>
          </span>
        </Link>

        <nav className={`main-nav ${open ? 'open' : ''}`} aria-label="Main">
          <ul>
            {links.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <a
            className="btn btn-solid nav-cta"
            href="mailto:info@sustunetech.com?subject=Consultation%20Enquiry"
          >
            Talk to us
          </a>
        </nav>

        <button
          className="nav-toggle"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </header>
  );
};

export default Navbar;
